import { createContext } from 'react'
import { useLocalStorage, useActiveText } from './hooks'
import { PAGE_SIZE } from './search'
import { CHAPTERS } from './bibles'

export const State = createContext()
export const ActiveText = createContext()

const initialState = {
  input: {
    bible: 1,
    book: 1,
    chapter: 1
  },
  output: {},
  chapters: CHAPTERS[1],
  status: 'loading',
  target: null,
  search: {
    input: '',
    query: '',
    bible: null,
    terms: [],
    results: [],
    status: 'idle',
    progress: 0,
    filter: null,
    shown: PAGE_SIZE,
    scroll: 0,
    back: false,
    history: []
  },
  active: {
    search: false,
    input: false,
    verses: {},
    control: {}
  }
}

const restoreState = state => state && {
  ...initialState,
  ...state,
  api: undefined, // zapisywane przez starsze wersje aplikacji
  chapters: state.chapters ?? CHAPTERS[state.input?.book ?? 1],
  status: Object.keys(state.output ?? {}).length ? 'done' : 'loading',
  target: null,
  search: {
    ...initialState.search,
    ...state.search,
    results: [],
    status: 'idle'
  },
  active: {
    ...initialState.active,
    ...state.active
  }
}

// Wyników wyszukiwania nie zapisujemy (mogą liczyć tysiące wersetów) – po odświeżeniu szukamy ponownie.
const storeState = state => ({
  ...state,
  search: {
    ...state.search,
    results: []
  }
})

const Context = ({children}) => {
  const [state, setState] = useLocalStorage('state', initialState, restoreState, storeState)

  const activeText = useActiveText(state)

  return (
    <State.Provider value={[state, setState]}>
      <ActiveText.Provider value={activeText}>
        {children}
      </ActiveText.Provider>
    </State.Provider>
  )
}

export default Context
